import VueRouter from 'vue-router';
import { magic } from '@gig/magic-sdk';
import { configQuery, modalService } from '@gig/magic-common';
import { RouteName } from '../../../routes/routes.constants';
import { areUserDetailsMissing, getUserUpdateParams } from '../helpers';
import {
    getUserDetailsInForm,
    userDetailsFormConfig,
} from '../helpers/user-details-config/user-details-form-config';
import {
    IFormBuilderStepConfiguration,
    IFormBuilderState,
} from '@gig/magic-form-builder';
import { IUpdateUserProfileParams } from '@gig/magic-sdk/dist/adapter/users/user';

interface IMagicCorexUserDetailsElement extends HTMLElement {
    formConfig: IFormBuilderStepConfiguration[];
    initialFormState: IFormBuilderState;
    submittedData: IUpdateUserProfileParams;
}

let isModalOpen = false;

export function initCorexUserDetailsGuard(router: VueRouter) {
    router.beforeEach(async (to, from, next) => {
        if (!magic.session.getUser() || to.name === RouteName.LOGOUT) {
            return next();
        }

        if (isModalOpen) {
            if (to.name !== RouteName.HOME) {
                return next(
                    new Error(
                        'Navigation canceled due to user block (user details)',
                    ),
                );
            } else {
                return next();
            }
        }

        if (
            (await areUserDetailsMissing()) &&
            (await configQuery<boolean>(`enableUserDetailsModal`))
        ) {
            isModalOpen = true;
            openModal();
            return next({ name: RouteName.HOME });
        }

        next();
    });
}

async function openModal() {
    const [formConfig, initialFormState] = await Promise.all([
        userDetailsFormConfig(true),
        getUserDetailsInForm(),
    ]);
    const modal = document.createElement(
        'magic-corex-user-details',
    ) as IMagicCorexUserDetailsElement;

    modal.formConfig = formConfig;
    modal.initialFormState = initialFormState;
    modal.addEventListener('submitData', async (event: Event) => {
        const customEvent = event as CustomEvent;
        const submittedData = await getUserUpdateParams(customEvent.detail[0]);

        modal.submittedData = submittedData;
    });

    const modalHeader = 'corex-user-details-modal.title';
    const modalOptions = {
        dismissible: false,
        dismissibleBackdrop: false,
        displayOnTop: true,
        keepAfterClear: true,
    };

    modalService.open(modalHeader, modal, modalOptions);

    modal.addEventListener('close', () => {
        isModalOpen = false;
    });
}
